import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CartService } from '../../services/cart.service';
import { CartItem } from '../../data/mock';
import { LocalStorageService } from '../../services/local-storage.service';
import { Product } from '../../Model/product';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { ToastService } from '../../services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { WebOrderMinimumDateTimeSetup } from '../../Model/web-order-minimum-date-time-setup';
import moment from "moment";
import { ProductOrderSummary } from '../../Model/product-order-summary';
import { ProductOrderSummaryServiceService } from '../../services/product-order-summary-service.service';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { LoginCustomerDetails } from '../../Model/login-customer-details';
import { GstSaleInvCumBosDto } from '../../Model/gst-sale-inv-cum-bos-dto';
import { ProductCartDto } from '../../Model/product-cart-dto';
import { ProductService } from '../../services/product.service';
import { WebOrderLocationSetup } from '../../Model/web-order-location-setup';
import { WebOrderStockDetailsDto } from '../../Model/web-order-stock-details-dto';
import { WebOrderMinimumValueSetup } from '../../Model/web-order-minimum-value-setup';
import { CartDetails } from '../../Model/cart-details';
import { CommonExternalModule } from '../../common/common-external-module';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent, FooterComponent],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.css',
})

export class CartComponent implements OnInit, OnDestroy {

  couponCode = '';
  currentUrl: string = '';
  googleId: string;
  googleProvider: string;
  locId: number;
  cartCount = 0;
  totTaxValue: number = 0;
  totDiscount: number = 0;
  gstAmt: number = 0;
  cessAmt: number = 0;
  grandTotal: number = 0;
  totalNetAmt: number = 0;
  totalSaleAmt: number = 0;
  roundedOffAmount: number = 0;
  netAmountBeforeRoundedOff: number = 0;
  deliveryCharge: number = 0;
  pincodeItem: number;
  totBasePremiumFlavourPrice: number = 0;
  totPremiumFlavourPrice: number = 0;
  isShowCheckOut: boolean = false;

  googleDetails: GoogleCustomer;
  deliveryLocation: WebOrderLocationSetup;
  minimumOrdeSetup: WebOrderMinimumValueSetup;
  googleCustomer: GoogleCustomer;
  cartDetails: CartDetails = new CartDetails();
  productWithStock: WebOrderStockDetailsDto[] = [];

  groupedCart: { [key: string]: CartItem[] } = {};
  cartProducts: Product[] = [];
  cart: CartItem[] = [];
  webOrderMinimumDateTimeList: WebOrderMinimumDateTimeSetup = new WebOrderMinimumDateTimeSetup();
  timeSlot2: string[][] = [];
  timeSlotAvl: string[] = [];
  productOrderSummary: ProductOrderSummary = new ProductOrderSummary();
  gstSaleInvcumBOS: GstSaleInvCumBosDto = new GstSaleInvCumBosDto();

  //Subscription
  private cartSubscription!: Subscription;
  private cartSetUpSubscription: Subscription;
  private locationSubscription: Subscription;
  private webOrderMinimumDateTimeSubcription: Subscription;
  private webOrderTimeSlotSubcription: Subscription;
  private webOrderMinimumOrderSubcription: Subscription;
  private stockSubscription: Subscription;

  constructor(
    private router: Router,
    private cartService: CartService,
    private localStorage: LocalStorageService,
    private apiFactory: ApiFactoryEndPoints,
    private toastService: ToastService,
    private productOrderSummaryService: ProductOrderSummaryServiceService,
    private navRoute: Router,
    private route: ActivatedRoute,
    public productService: ProductService
  ) { }

  ngOnInit() {
    this.currentUrl = window.location.host.replace(':', '');
    const loc = this.localStorage.getItem("location_code");
    this.locId = loc ? JSON.parse(loc) : null;
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.getAllProducts();
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }

    if (this.cartSetUpSubscription) {
      this.cartSetUpSubscription.unsubscribe();
    }
  }

  buildGroupedCart() {
    this.groupedCart = this.cartProducts.reduce((groups: any, item) => {
      const key = item.productSubGroup.productGroup.productMatrix.productMatrixName || 'Unknown Restaurant';
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(item);
      return groups;
    }, {});
  }

  getAllProducts() {
    // Filter products if a product code is provided
    this.cartProducts = this.filterCartProductsByCode();

    this.buildGroupedCart();
    this.getProductDeliveryTimeAndStockDetails();
  }

  filterCartProductsByCode(): any[] {
    const productCode = Number(this.route.snapshot.queryParamMap.get('code'));
    let cartProducts = this.productService.getLocalCartProducts();

    // Perform shelf-life validation before returning the cart products
    cartProducts = this.removeProductsWithLowShelfLife(cartProducts);

    if (!productCode) {
      return cartProducts; // No product code provided, return all filtered products
    }

    // Filter products where any of the conditions match
    return cartProducts.filter(c =>
      [c.product_Code, c.freeByProductCode, c.designForProductCode].includes(productCode)
    );
  }

  removeProductsWithLowShelfLife(products: Product[]): Product[] {
    const minSelfLife = this.deliveryLocation?.minSelfLife;

    if (!minSelfLife) return products; // No shelf-life restriction

    // Separate valid and invalid products
    const removedProducts = products.filter(p => p.shelf_Life_In_Hours < minSelfLife);
    const updatedProducts = products.filter(p => p.shelf_Life_In_Hours >= minSelfLife);

    if (removedProducts.length > 0) {
      this.productService.removeAllProductsFromCart(removedProducts, updatedProducts);
    }

    return updatedProducts;
  }

  getProductDeliveryTimeAndStockDetails(): Promise<void> {
    return new Promise((resolve, reject) => {
      const locId = JSON.parse(this.localStorage.getItem('location_code'));

      this.cartService.getMinimumDateTimeDetails(this.apiFactory.getWebOrderMinimumDateTimeDetails, this.currentUrl).subscribe((data) => {
        if (data) {
          this.webOrderMinimumDateTimeList.deliveryTime = data.deliveryTime;
          this.webOrderMinimumDateTimeList.maxDeliveryTime = data.maxDeliveryTime;

          this.cartService.getTimeSlotList(this.apiFactory.getTimeSlotDetailsByUrl, this.currentUrl).subscribe((slotData) => {
            this.timeSlot2 = slotData.map((element) => [element.fromTime, element.toTime]);
            this.timeSlotAvl = this.timeSlot2.map(([fromTime, toTime]) => `${fromTime}-${toTime}`);

            var orderDuration = new Date();
            orderDuration.setHours(orderDuration.getHours() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[0]));
            orderDuration.setMinutes(orderDuration.getMinutes() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[1]));

            let maxOrderDuration = moment().add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[0]), "hours")
              .add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[1]), "minutes");

            const productCodes = this.cartProducts.filter(d => d.cartProductType == 'Product').map(p => p.product_Code);

            if (productCodes.length > 0) {
              // Call stock API only if productCodes exist
              this.productService.getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, locId ?? 0, productCodes, this.currentUrl, 'delivery')
                .subscribe((stockList: WebOrderStockDetailsDto[]) => {
                  this.updateCartProductsWithStockAndDelivery(stockList, orderDuration, maxOrderDuration);
                  resolve();
                }, reject);
            } else {
              // No product codes – just update delivery logic
              this.updateCartProductsWithStockAndDelivery([], orderDuration, maxOrderDuration);
              resolve();
            }
          }, reject);
        } else {
          reject("Invalid delivery data");
        }
      }, reject);
      this.getWebOrderMinimumOrderSetUpList();
    });
  }

  private updateCartProductsWithStockAndDelivery(stockList: WebOrderStockDetailsDto[], orderDuration: Date, maxOrderDuration: moment.Moment): void {
    this.cartProducts.forEach((product) => {
      const stockData = stockList.find(stock => stock.productCode === product.product_Code);
      const minQty = product.minimum_Order_Quantity || 0;

      let isAvailable = true;

      if (stockData) {
        if (stockData.manualStockAllow) {
          isAvailable = stockData.manualStock >= minQty;
        } else if (stockData.systemStockAllow) {
          isAvailable = stockData.systemStock >= minQty;
        }
      }

      product.outOfStock = !isAvailable;
      product.stockAvailable = isAvailable;

      let minOrderDate = new Date();
      minOrderDate.setDate(minOrderDate.getDate() + product.minimum_Order_Time);

      let greaterDate = orderDuration > minOrderDate ? orderDuration : minOrderDate;
      let todayDate = moment(greaterDate);

      const today = moment().startOf('day');

      // Check if user-selected future date should be retained
      let useExistingDateTime =
        product.cartProductType === 'Make To Order' &&
        product.deliveryDate &&
        product.deliveryTime &&
        moment(product.deliveryDate).isAfter(today, 'day');

      if (useExistingDateTime) {
        todayDate = moment(product.deliveryDate + ' ' + product.deliveryTime);
      } else {
        product.deliveryDate = todayDate.format("YYYY-MM-DD");
        product.defaultDate = todayDate.format("YYYY-MM-DD");
        product.deliveryTime = todayDate.format("HH:mm");
      }

      product.maxDeliveryDate = maxOrderDuration.format("YYYY-MM-DD");
      product.maxDeliveryTime = maxOrderDuration.format("HH:mm");

      let totTime = todayDate.hours() * 60 + todayDate.minutes();
      product.timeSlotAvl = [];
      let matchedSlot = false;

      for (const e of this.timeSlot2) {
        let fromSlotTime = Number(e[0].split(":")[0]) * 60 + Number(e[0].split(":")[1]);
        if (totTime < fromSlotTime) {
          let tSlot = `${e[0]}-${e[1]}`;
          product.timeSlotAvl.push(tSlot);
          if (!matchedSlot && !useExistingDateTime) {
            product.deliveryTime = tSlot;
            matchedSlot = true;
          }
        }
      }

      if (!matchedSlot && !useExistingDateTime) {
        todayDate = todayDate.clone().add(1, 'day');
        product.deliveryDate = todayDate.format("YYYY-MM-DD");
        product.timeSlotAvl = this.timeSlot2.map(slot => `${slot[0]}-${slot[1]}`);
        product.deliveryTime = product.timeSlotAvl[0];
      }

      const deliveryDay = moment(product.deliveryDate).startOf('day');

      if (deliveryDay.isSame(today, 'day')) {
        product.deliveryLabel = 'Today';
      } else if (deliveryDay.diff(today, 'days') === 1) {
        product.deliveryLabel = 'Tomorrow';
      } else {
        product.deliveryLabel = deliveryDay.format('Do MMM');
      }

      // Apply main product's delivery details to free product
      if (product.freeByProductCode) {
        const mainProduct = this.cartProducts.find(p => p.product_Code === product.freeByProductCode);
        if (mainProduct) {
          product.deliveryDate = mainProduct.deliveryDate;
          product.defaultDate = mainProduct.defaultDate;
          product.deliveryTime = mainProduct.deliveryTime;
          product.timeSlotAvl = [...mainProduct.timeSlotAvl];
          product.deliveryLabel = mainProduct.deliveryLabel;
        }
      }

    });

    this.localStorage.setItem("avct_item", JSON.stringify(this.cartProducts));
    this.isShowCheckOut = true;
    this.validateNetAmount();
  }

  getWebOrderMinimumOrderSetUpList() {
    this.webOrderMinimumOrderSubcription = this.cartService.getMinimumOrderList(this.currentUrl).subscribe((data) => {
      this.minimumOrdeSetup = data;
    });
  }

  removeCartProduct(product: Product) {
    this.productService.removeLocalCartProduct(product);
    this.cartProducts = this.productService.getLocalCartProducts();
    this.buildGroupedCart();
    this.validateNetAmount();
  }

  validateNetAmount() {
    this.totalNetAmt = 0;
    this.totalSaleAmt = 0;
    this.totDiscount = 0;
    this.gstAmt = 0;
    this.cessAmt = 0;
    this.totBasePremiumFlavourPrice = 0;
    this.totPremiumFlavourPrice = 0;
    this.roundedOffAmount = 0;
    this.netAmountBeforeRoundedOff = 0;

    this.cartProducts.forEach((element) => {
      console.log(element)
      if (element.orderQuantityKgs == null) {
        this.totalSaleAmt += Number((element.orderQuantity * element.sale_Price).toFixed(2));
        if (element.discountAmt) {
          this.totDiscount += Number((element?.discountAmt * element.orderQuantity).toFixed(2));
        }
        if (element.taxAmount) {
          this.gstAmt += Number((element.orderQuantity * element?.taxAmount).toFixed(2));
        }
        if (element.cessAmount) {
          this.cessAmt += Number((element.orderQuantity * element?.cessAmount).toFixed(2));
        }
        this.totTaxValue = (this.totalSaleAmt + this.totBasePremiumFlavourPrice) - this.totDiscount;
        // this.totalNetAmt = element.orderQuantity * element.net_Sale_Price;
        this.totalNetAmt = this.totTaxValue + this.gstAmt + this.cessAmt;
      } else {
        this.totalSaleAmt += Number((element.orderQuantityKgs * element.sale_Price).toFixed(2));
        this.totBasePremiumFlavourPrice += Number((element.basePremiumFlavourPrice * element.orderQuantityKgs).toFixed(2));
        this.totPremiumFlavourPrice += Number((element.premiumFlavourPrice * element.orderQuantityKgs).toFixed(2));
        if (element.discountAmt) {
          this.totDiscount += Number((element?.discountAmt * element.orderQuantityKgs).toFixed(2));
        }
        if (element.taxAmount) {
          this.gstAmt += Number((element.orderQuantityKgs * element?.taxAmount).toFixed(2));
        }
        if (element.cessAmount) {
          this.cessAmt += Number((element.orderQuantityKgs * element?.cessAmount).toFixed(2));
        }
        this.totTaxValue = (this.totalSaleAmt + this.totBasePremiumFlavourPrice) - this.totDiscount;
        // this.totalNetAmt = element.orderQuantityKgs * element.net_Sale_Price + element.orderQuantityKgs * element.premiumFlavourPrice;
        this.totalNetAmt = this.totTaxValue + this.gstAmt + this.cessAmt;
      }
    });
    this.roundedOffAmount = Math.round(this.totalNetAmt) - this.totalNetAmt;
    this.netAmountBeforeRoundedOff = this.totalNetAmt;
    this.totalNetAmt = Math.round(this.totalNetAmt);
    this.grandTotal = this.totalNetAmt + this.deliveryCharge;
  }

  checkout() {
    // this.toastService.showWarningToast("Coming Soon!");
    // return;
    this.isShowCheckOut = false;
    const productCodes = this.cartProducts.filter(d => d.cartProductType == 'Product').map(p => p.product_Code);

    if (!this.locId) {
      this.locationSubscription = this.cartService
        .getLocIdByUrl(this.apiFactory.getLocationByCurrentUrl, this.currentUrl)
        .subscribe((data: number[]) => {
          if (data.length != 0) {
            this.localStorage.setItem("location_code", JSON.stringify(data[0]));
            this.locId = data[0];
          } else {
            this.toastService.showErrorToast("No Location Setup not done yet");
          }
        })
    }

    if (this.locId) {
      this.locationSubscription = this.cartService
        .getCompanyByLocId(this.apiFactory.getLocationByLocationCode, this.locId)
        .subscribe((data: any) => {
          if (data && data.status === 'Active') {
            if (productCodes.length > 0) {
              this.stockSubscription = this.productService
                .getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, this.locId, productCodes, this.currentUrl, 'delivery')
                .subscribe({
                  next: (stockList: WebOrderStockDetailsDto[]) => {
                    this.productWithStock = stockList;

                    this.cartProducts.forEach((element) => {
                      if (this.isShowCheckOut) return;

                      const stockData = stockList.find(p => p.productCode === element.product_Code);

                      if (stockData) {
                        element.systemStock = stockData.systemStock;
                        element.manualStock = stockData.manualStock;
                        element.systemStockAllow = stockData.systemStockAllow;
                        element.manualStockAllow = stockData.manualStockAllow;

                        if (element.cartProductType === 'Product') {
                          // Manual Stock Check
                          if (stockData.manualStockAllow && element.orderQuantity > stockData.manualStock) {
                            this.toastService.showErrorToast(`${element.product_Name} is out of stock, available: ${stockData.manualStock}`);
                            this.isShowCheckOut = true;
                            return;
                          }

                          // System Stock Check
                          if (!stockData.manualStockAllow && stockData.systemStockAllow && element.orderQuantity > stockData.systemStock) {
                            this.toastService.showErrorToast(`${element.product_Name} is out of stock, available: ${stockData.systemStock}`);
                            this.isShowCheckOut = true;
                            return;
                          }
                        }
                      }
                    });

                    if (!this.isShowCheckOut) {
                      this.getWebOrderMinMaxTimeSetUp();
                    }
                  },
                  error: (error: HttpErrorResponse) => {
                    this.isShowCheckOut = true;
                    this.toastService.showErrorToast('Something went wrong while checking stock.');
                  }
                });
            } else {
              this.getWebOrderMinMaxTimeSetUp();
            }
          } else {
            this.isShowCheckOut = true;
            this.toastService.showErrorToast("Location can't place order");
          }
        }, (error: HttpErrorResponse) => {
          this.isShowCheckOut = true;
          this.toastService.showErrorToast("Something went wrong..");
        });
    } else {
    }
  }

  getWebOrderMinMaxTimeSetUp() {
    this.webOrderMinimumDateTimeSubcription = this.cartService.getWebOrderMinimumDateTimeDetails(this.currentUrl).subscribe((data) => {
      this.webOrderMinimumDateTimeList = data;
      this.getSummary();
    },
      (error: HttpErrorResponse) => {
        this.isShowCheckOut = true;
      }
    );
  }

  getSummary() {
    // this.pincodeItem = JSON.parse(this.localStorage.getItem("pincode_item"));
    let currDate = moment().format("YYYY-MM-DD");

    let orderDuration = moment().add(
      Number(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[0]), "hours"
    ).add(
      Number(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[1]), "minutes"
    );

    let maxOrderDuration = moment().add(
      Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[0]), "hours"
    ).add(
      Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[1]), "minutes"
    );


    this.cartProducts.forEach((element) => {
      // PRODUCT: Calculate product-level minimum order date (in days)
      let productMinDays = Number(element.minimum_Order_Time) || 0;
      let productMinMoment = moment().add(productMinDays, 'days');

      // FINAL: Choose the later of setup or product minimum time
      let finalDeliveryMoment = productMinMoment.isAfter(orderDuration) ? productMinMoment : orderDuration;

      // Set delivery date fields
      element.deliveryDate = finalDeliveryMoment.format("YYYY-MM-DD");
      element.defaultDate = finalDeliveryMoment.format("YYYY-MM-DD");
      element.maxDeliveryDate = maxOrderDuration.format("YYYY-MM-DD");
      element.maxDeliveryTime = maxOrderDuration.format("HH:mm");

      // TIME SLOT MATCHING: Based on setup-level time (orderDuration)
      let setupMins = orderDuration.hours() * 60 + orderDuration.minutes();
      element.timeSlotAvl = [];
      let matchedSlot = false;

      for (const slot of this.timeSlot2) {
        let fromMins = Number(slot[0].split(":")[0]) * 60 + Number(slot[0].split(":")[1]);
        if (setupMins < fromMins) {
          let tSlot = `${slot[0]}-${slot[1]}`;
          element.timeSlotAvl.push(tSlot);

          if (!matchedSlot) {
            element.deliveryTime = tSlot;
            matchedSlot = true;
          }
        }
      }

      // If no slot matched today, move to next day and show all slots
      if (!matchedSlot) {
        finalDeliveryMoment = finalDeliveryMoment.clone().add(1, 'day');
        element.deliveryDate = finalDeliveryMoment.format("YYYY-MM-DD");
        element.timeSlotAvl = this.timeSlot2.map(slot => `${slot[0]}-${slot[1]}`);
        element.deliveryTime = element.timeSlotAvl[0];
      }
      // }
      // Maintain discount rate
      element.discountRate = element.discountRate || 0.0;

      // Sync delivery details for offer products
      if (element.freeByProductCode) {
        const mainProduct = this.cartProducts.find(p => p.product_Code === element.freeByProductCode);
        if (mainProduct) {
          element.deliveryDate = mainProduct.deliveryDate;
          element.defaultDate = mainProduct.defaultDate;
          element.deliveryTime = mainProduct.deliveryTime;
          element.timeSlotAvl = [...mainProduct.timeSlotAvl];
          element.deliveryLabel = mainProduct.deliveryLabel;
        }
      }
    });

    //Here set Summary data
    this.productOrderSummary.cartProducts = this.cartProducts;
    this.productOrderSummary.totTaxValue = this.totTaxValue;
    this.productOrderSummary.totDiscount = this.totDiscount;
    this.productOrderSummary.gstAmt = this.gstAmt;
    this.productOrderSummary.cessAmt = this.cessAmt;
    this.productOrderSummary.totalPrice = this.grandTotal;
    this.productOrderSummary.pincode = this.pincodeItem;
    this.productOrderSummary.totBasePremiumFlavourPrice = this.totBasePremiumFlavourPrice;
    this.productOrderSummary.totPremiumFlavourPrice = this.totPremiumFlavourPrice;
    this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);

    this.googleId = JSON.parse(this.localStorage.getItem("google_id"));
    this.googleProvider = JSON.parse(this.localStorage.getItem("google_provider"));

    this.googleDetails = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    if (this.googleDetails != null) {
      let loginDeliveryAddress: LoginCustomerDetails = new LoginCustomerDetails();
      loginDeliveryAddress.firstName = this.googleDetails.firstName;
      loginDeliveryAddress.lastName = this.googleDetails.lastName;
      loginDeliveryAddress.name = this.googleDetails.name;
      loginDeliveryAddress.email = this.googleDetails.email;
      loginDeliveryAddress.phoneNo = this.googleDetails.phoneNo;
      this.gstSaleInvcumBOS.loginDeliveryAddress = loginDeliveryAddress;
    }

    this.gstSaleInvcumBOS.notes = "Bill From Order";
    this.gstSaleInvcumBOS.invoiceType = "B2C";
    this.gstSaleInvcumBOS.billType = "Web Order";
    this.gstSaleInvcumBOS.status = "Confirmed";

    //Set Product Cart Dto
    var arr = new Array();
    this.cartProducts.forEach((element) => {
      if (!element.freeByProductCode) {
        let productCartDto: ProductCartDto = new ProductCartDto();
        productCartDto.promotionOfferId = element.offerId;
        productCartDto.offerId = element.offerId;
        productCartDto.designForProductCode = element.designForProductCode;
        productCartDto.productCode = element.product_Code;
        productCartDto.productName = element.product_Name;
        productCartDto.qty = element.orderQuantity;
        productCartDto.basePremiumFlavourPrice = element.basePremiumFlavourPrice * productCartDto.qty;
        productCartDto.premiumFlavourPrice = element.premiumFlavourPrice * productCartDto.qty;
        productCartDto.price = element.sale_Price + element.basePremiumFlavourPrice;
        productCartDto.total = productCartDto.qty * productCartDto.price;
        if (element.discountRate === undefined || element.discountRate == null) {
          productCartDto.discPercent = 0.0;
          productCartDto.discAmt = 0.0;
        } else {
          productCartDto.discPercent = element.discountRate;
          productCartDto.discAmt = element.discountAmt * productCartDto.qty;
        }

        productCartDto.baseAmt = productCartDto.total;
        productCartDto.netAmt = element.net_Sale_Price + element.premiumFlavourPrice;
        productCartDto.sgstRate = element.tax.taxRate / 2;
        productCartDto.cgstRate = element.tax.taxRate / 2;
        productCartDto.igstRate = 0.0;
        productCartDto.ugstRate = 0.0;
        productCartDto.cessRate = element.cess?.cessRate;

        productCartDto.taxRate = element.tax?.taxRate;
        productCartDto.cartProductType = element.cartProductType;
        productCartDto.color = element.color;
        productCartDto.shape = element.shape;
        productCartDto.composition = element.composition;
        productCartDto.dimension = element.dimension;
        productCartDto.note = element.note;
        productCartDto.productUnit = element.product_Unit;
        productCartDto.productType = element.product_Type;
        productCartDto.maxDiscountPercentage = element.max_Discount_Percentage;
        productCartDto.hsnCode = element.hsn_Code;
        if (element.cartProductType == "Make To Order") {
          productCartDto.subGroupCode = element.subGroupCode;
        } else {
          productCartDto.subGroupCode = element.productSubGroup?.refNo;
        }
        productCartDto.deliveryDate = element.deliveryDate;
        productCartDto.deliveryTime = element.deliveryTime;
        productCartDto.fileNames = element.fileNames;

        arr.push(productCartDto);
      } else {
        let productCartDto: ProductCartDto = new ProductCartDto();
        productCartDto.promotionOfferId = element.offerId;
        productCartDto.offerId = element.offerId;
        productCartDto.freeByProductCode = element.freeByProductCode;
        productCartDto.designForProductCode = element.designForProductCode;
        productCartDto.productCode = element.product_Code;
        productCartDto.productName = element.product_Name;
        productCartDto.cartProductType = element.cartProductType;
        productCartDto.productUnit = element.product_Unit;
        productCartDto.productType = element.product_Type;
        productCartDto.hsnCode = element.hsn_Code;
        productCartDto.subGroupCode = element.productSubGroup?.refNo;
        productCartDto.qty = element.orderQuantity;
        productCartDto.price = element.sale_Price;
        productCartDto.total = productCartDto.qty * productCartDto.price;
        productCartDto.discPercent = 0.0;
        productCartDto.discAmt = 0.0;
        productCartDto.baseAmt = productCartDto.total;
        productCartDto.netAmt = element.net_Sale_Price;
        productCartDto.taxRate = element.tax?.taxRate;
        productCartDto.sgstRate = 0.0;
        productCartDto.cgstRate = 0.0;
        productCartDto.igstRate = 0.0;
        productCartDto.ugstRate = 0.0;
        productCartDto.cessRate = element.cess?.cessRate;
        productCartDto.deliveryDate = element.deliveryDate;
        productCartDto.deliveryTime = element.deliveryTime;
        productCartDto.fileNames = element.fileNames;
        productCartDto.rate = element.rate;
        productCartDto.maxDiscountPercentage = element.max_Discount_Percentage;
        productCartDto.netAmountForLocation = element.netAmountForLocation;
        productCartDto.totalAmount = element.subTotal;
        arr.push(productCartDto);
      }
    });
    this.gstSaleInvcumBOS.details = arr;
    this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);
    this.isShowCheckOut = true;

    this.googleId = JSON.parse(this.localStorage.getItem("google_id"));
    if (this.googleId != null) {
      this.navRoute.navigate(["/delivery-address"]);
    } else {
      this.navRoute.navigate(["/login", "checkout"]);
    }
  }

  increaseQuantity(item: any) {
    item.orderQuantity++;
    this.updateItem(item);
  }

  decreaseQuantity(item: any) {
    if (item.orderQuantity > 1) {
      item.orderQuantity--;
      this.updateItem(item);
    }
  }

  updateItem(product: Product) {
    if (product.orderQuantity <= 0) {
      product.orderQuantity = 1;
    }

    // Ensure orderQuantity is at least 1 and round it properly
    product.orderQuantity = Math.max(1, Math.floor(product.orderQuantity));

    const cartProducts: Product[] = this.cartProducts;
    var productList: any = [];

    if (cartProducts.some((temp) => temp.product_Code == product.product_Code && temp.cartProductType == "Product")) {
      let itemIndex = cartProducts.findIndex((item) => item.product_Code == product.product_Code);
      if (itemIndex >= 0)
        cartProducts[itemIndex] = product;
    }
    if (cartProducts.some((temp) => temp.designForProductCode == product.product_Code && temp.cartProductType == "Product")) {
      let designIndex = cartProducts.findIndex(e => e.designForProductCode === product.product_Code);
      if (designIndex >= 0)
        cartProducts[designIndex].orderQuantity = product.orderQuantity;
    }

    if (this.googleCustomer != null) {
      cartProducts.forEach((element) => {
        if (element.cartProductType == "Product") {
          element.status = "Not placed";
          productList.push(element);
        }
      });

      this.cartDetails.status = "Not placed";
      this.cartDetails.logInCustomerEmail = this.googleCustomer.email;
      this.cartDetails.currentUrl = this.currentUrl;
      this.cartDetails.product = productList;
      this.cartSetUpSubscription = this.productService.insertCartSetUp(this.apiFactory.insertProductCart, this.cartDetails)
        .subscribe((response: any) => { });
    }
    this.localStorage.setItem("avct_item", JSON.stringify(cartProducts));
    this.validateNetAmount();
  }

  goBack() {
    this.router.navigate(['/']);
  }

  goHome() {
    this.router.navigate(['/']);
  }

  getProductWithStock() {
    this.isShowCheckOut = false;
    const deliveryType = JSON.parse(this.localStorage.getItem("delivery_type")) ?? 'delivery';
    const productCodes = this.cartProducts.filter(d => d.cartProductType == 'Product').map(p => p.product_Code);

    if (this.locId) {
      this.locationSubscription = this.cartService
        .getCompanyByLocId(this.apiFactory.getLocationByLocationCode, this.locId)
        .subscribe((data: any) => {
          if (data && data.status === 'Active') {
            // if (this.deliveryType) {
            if (productCodes.length > 0) {
              this.stockSubscription = this.productService
                .getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, this.locId, productCodes, this.currentUrl, deliveryType)
                .subscribe({
                  next: (stockList: WebOrderStockDetailsDto[]) => {
                    this.productWithStock = stockList;

                    this.cartProducts.forEach((element) => {
                      if (this.isShowCheckOut) return;

                      const stockData = stockList.find(p => p.productCode === element.product_Code);

                      if (stockData) {
                        element.systemStock = stockData.systemStock;
                        element.manualStock = stockData.manualStock;
                        element.systemStockAllow = stockData.systemStockAllow;
                        element.manualStockAllow = stockData.manualStockAllow;

                        if (element.cartProductType === 'Product') {
                          // Manual Stock Check
                          if (stockData.manualStockAllow && element.orderQuantity > stockData.manualStock) {
                            this.toastService.showErrorToast(`${element.product_Name} is out of stock, available: ${stockData.manualStock}`);
                            this.isShowCheckOut = true;
                            return;
                          }

                          // System Stock Check
                          if (!stockData.manualStockAllow && stockData.systemStockAllow && element.orderQuantity > stockData.systemStock) {
                            this.toastService.showErrorToast(`${element.product_Name} is out of stock, available: ${stockData.systemStock}`);
                            this.isShowCheckOut = true;
                            return;
                          }
                        }
                      }
                    });

                    if (!this.isShowCheckOut) {
                      this.getWebOrderMinMaxTimeSetUp();
                    }
                  },
                  error: (error: HttpErrorResponse) => {
                    this.isShowCheckOut = true;
                    this.toastService.showErrorToast('Something went wrong while checking stock.');
                  }
                });
            } else {
              this.getWebOrderMinMaxTimeSetUp();
            }
            // } else {
            //   this.openStorePickupDialog();
            // }
          } else {
            this.isShowCheckOut = true;
            this.toastService.showErrorToast("Location can't place order");
          }
        }, (error: HttpErrorResponse) => {
          this.isShowCheckOut = true;
          this.toastService.showErrorToast("Something went wrong..");
        });
    } else {
      // this.openStorePickupDialog();
    }
  }

}